import React from 'react';
import styles from '../Nexsets.module.scss';
import { Nexset } from 'new/entities/Nexset';
import { Stack } from 'new/elements/Stack';
import { SourceName } from 'new/elements/SourceName';
import { Typography } from '@mui/material';
import { ChipBadge } from 'new/elements/ChipBadge';

interface ListApiItemsProps {
  items: Nexset[];
}

const Item = ({ item }: { item: Nexset }) => {
  return (
    <div className={styles.itemContainer}>
      <SourceName type={item.isDetected ? 'source' : 'nexset'} icon={item.sourceIcon} />
      <Stack className={styles.itemInfo}>
        <Typography variant="caption">{item.name}</Typography>
        <Typography variant="body3">{item.description}</Typography>
        <Typography variant="body3">
          {item.transformedCount} Transformed Nexsets • {item.destinationCount} Destinations •{' '}
          {item.sharesCount} Shares
        </Typography>
      </Stack>
      <ChipBadge label={'ID: ' + item.id} color="success" />
    </div>
  );
};

export const ListApiItems = (props: ListApiItemsProps) => {
  return (
    <Stack flex={1} className={styles.itemsContainer}>
      {props.items.slice(0, 7).map((item) => (
        <Item key={item.id} item={item} />
      ))}
    </Stack>
  );
};
